import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './page/login/login.component';
import { RegisterComponent } from './page/register/register.component';
import { SharedModule } from '../../shared/shared.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AuthRoutingModule } from './auth.routing';
import { ForgetPwComponent } from './page/forget-pw/forget-pw.component';

@Pipe({name: 'movementType'})
export class Movement implements PipeTransform
{
    /** * * @param value * @returns {string} */
    transform(value: string): string
    {
        var movement = value;
        switch (value) {
          case 'import':
            movement = 'Import of finished packaged liquor'
            break;
          case 'export':
            movement = 'Export of finished package liquor'
            break;
          case 'internal':
            movement = 'Internal movement of finished package liquor'
            break;
          case 'domestic':
            movement = 'Internal movement of finished package liquor'
            break;
          case 'transit':
            movement = 'Transit movement of finished package liquor'
            break;
          case 'bottling':
            movement = 'Bottling Plant to WBSBCL Depot'
            break;
          case 'wbsbcl':
            movement = 'Bottling Plant to WBSBCL Depot'
            break;
          case 'manufactory':
            movement = 'Distillery to CSBP or FL Manufactory'
            break;
          case 'empty':
            movement = 'Transit Movement of Empty Tankers'
            break;
          case 'milk':
            movement = 'Transit Movement of Milk Tankers'
            break;
          case 'oil':
            movement = 'Transit Movement of Oil Tankers'
            break;
        
          default:
            break;
        }
        return movement;
    }
}

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    Movement,
    ForgetPwComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
    AngularMultiSelectModule
  ]
})
export class AuthModule { }
